import api from "api/api";
import { DATATRACK_MODELS } from "constants/constants";

export const getUserDatatrackQuery = async ({
  id,
  model,
  userScope,
  ids,
  personIds,
}) => {
  const idsParam = ids?.map((e) => `&ids=${e}`).join("") ?? "";
  const personIdsParam = [...(personIds ?? []), id]
    .map((e) => `&person_ids=${e}`)
    .join("");

  const url = () => {
    switch (model) {
      case DATATRACK_MODELS.INTERNAL_TRAINING_COMMENTS:
        return `/datatrack/internal_training/comments/user/${id}?scope=${userScope}`;

      case DATATRACK_MODELS.DASHBOARD_COMMENTS:
        return `/datatrack/dashboard_comment?scope=${userScope}${idsParam}${personIdsParam}`;

      default:
        return `/datatrack/${model}/user/${id}?scope=${userScope}`;
    }
  };

  return api.get(url());
};

export const createUserDatatrackQuery = async ({ data, model, userScope }) =>
  await api.post(
    `/datatrack/${
      model === "internal_training_comments"
        ? "internal_training/comments"
        : model
    }?scope=${userScope}`,
    data
  );

export const updateUserDatatrackQuery = async ({
  id,
  data,
  model,
  userScope,
}) => {
  const url = () => {
    switch (model) {
      case DATATRACK_MODELS.INTERNAL_TRAINING_COMMENTS:
        return `/datatrack/internal_training/comments/${id}?scope=${userScope}`;
      case DATATRACK_MODELS.CONTRACT:
        return `/datatrack/contract/person/table?scope=${userScope}`;
      default:
        return `/datatrack/${model}/${id}?scope=${userScope}`;
    }
  };
  return await api.put(url(), data);
};

export const deleteUserDatatrackQuery = async ({ id, model, userScope }) => {

  return await api.delete(
    `/datatrack/${
      model === "internal_training_comments"
        ? "internal_training/comments"
        : model
    }/${id}?scope=${userScope}`
  );
};

export const getModalAccessForDatatrackQuery = async ({ id, userScope }) =>
  await api.get(`/datatrack/access/user/${id}?scope=${userScope}`);

export const getDatatrackByFilterQuery = async ({
  endpoint,
  scope,
  personId,
}) => {
  const params = new URLSearchParams();

  if (scope) params.append("scope", scope);
  if (personId) params.append("person-id", personId);

  return await api.get(`/datatrack/${endpoint}/filters?${params.toString()}`);
};
